<ng-container *ngIf="!isLoadingItem">
    <a [href]="article.url" target="_blank">
        <div class="slide-min__img">
            <img [src]="article.previewImage" width="675" height="390"/>
            <div *ngIf="article.articlesContentTypes" class="slide-min__icons">
                <div *ngFor="let type of article.articlesContentTypes" class="slide-min__mini-icon">
                    <img [src]="getArticleTypeIcon(type)" width="12" height="16" alt="icon">
                </div>
            </div>
        </div>
    </a>
    <div class="slide-min__top">
        <div class="slide-min__tips">
            <ng-container *ngIf="article.articlesSubjectsList">
                <a *ngFor="let subject of article.articlesSubjectsList" class="slide-min__label">{{subject.value}}</a>
            </ng-container>
        </div>
        <time *ngIf="article.date" class="slide-min__date">{{article.date | date: 'dd.MM.yy'}}</time>
    </div>
    <a [href]="article.url" class="slide-min__name slide-min__name--bold" target="_blank">{{article.previewTitle}}</a>
    <div class="slide-min__name">{{article.previewDescription}}</div>    
</ng-container>
<ng-container *ngIf="isLoadingItem">
    <div class="skeleton">
        <div class="slide-min__img">
            <app-skeleton [height]="175"/>
        </div>
    </div>
    <div class="slide-min__top">
        <div class="slide-min__tips"></div>
        <app-skeleton class="slide-min__date" [type]="'text'" [symbolsCount]="7"/>
    </div>
    <app-skeleton class="slide-min__name slide-min__name--bold" [type]="'text'" [symbolsCount]="16"/>
    <app-skeleton class="slide-min__name" [type]="'text'" [symbolsCount]="120"/> 
</ng-container>